import React, { useContext } from 'react'
import { SettingProviderStep2 } from "app/React/Components/Form/Step2/SettingContextStep2";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function SettingContainerStep2({ children }) {
  const {
    checkedChargings,
    setCheckedChargings,
  } = useContext(ConfiguratorContext)

  const contextObject = {
    getCheckedForSetting: (settingId) => {
      const newChecked = { ...checkedChargings }
      return Object.keys(newChecked).filter(function (key) {
        return newChecked[key] === settingId
      })
    },

    markChecked: (id, settingId) => {
      let checkedEntries = Object.entries(checkedChargings)
      const newChecked = Object.fromEntries(checkedEntries)

      if (!Object.keys(newChecked).includes(String(id))) {
        newChecked[String(id)] = String(settingId)
        setCheckedChargings(newChecked)
      }
    },

    markUnchecked: (id) => {
      const newChecked = { ...checkedChargings }
      delete newChecked[id]
      setCheckedChargings(newChecked)
    },

    isChecked: (id) => {
      return Object.keys(checkedChargings).includes(id)
    }
  }

  return (
    <div>
      <SettingProviderStep2 value={contextObject}>
        {children}
      </SettingProviderStep2>
    </div>
  )
}
